export default "__VITE_ASSET__BNCUFuQS__"